export default import.meta.ROLLDOWN_FILE_URL_LxL$VFbUxVtNn_zbs7yz7w